// POST JSON to an admin endpoint outside Inertia's router (used by the AI
// draft endpoints, which return a draft as JSON without committing anything).
export async function postJson<T>(url: string, body: unknown): Promise<T> {
  const token =
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": token,
    },
    credentials: "same-origin",
    body: JSON.stringify(body),
  })
  const data = (await response.json().catch(() => ({}))) as T & { error?: string }
  if (!response.ok) {
    throw new Error(data.error ?? `Request failed (${response.status})`)
  }
  return data
}
